import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin, setToken } from "@/lib/adminApi";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Loader2 } from "lucide-react";

function formatError(detail) {
  if (!detail) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await adminLogin(form.email, form.password);
      setToken(data.token);
      nav("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-plum-dark px-4 grain">
      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-8">
          <span className="inline-grid place-items-center w-14 h-14 rounded-full bg-gold text-plum font-heading text-3xl font-semibold mb-4">G</span>
          <h1 className="font-heading text-4xl text-cream font-semibold">Ministry Admin</h1>
          <p className="text-cream/60 text-sm mt-2">Greater Faith International Ministries</p>
        </div>
        <form onSubmit={submit} className="bg-cream rounded-2xl p-8 shadow-2xl" data-testid="admin-login-form">
          <div className="space-y-4">
            <div>
              <Label className="text-plum text-sm">Email</Label>
              <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-email" className="h-12 bg-white border-plum/15 mt-1" placeholder="admin@greaterfaithintl.org" />
            </div>
            <div>
              <Label className="text-plum text-sm">Password</Label>
              <Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-password" className="h-12 bg-white border-plum/15 mt-1" placeholder="Your password" />
            </div>
            {error && <p className="text-destructive text-sm" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full py-4 rounded-full bg-plum hover:bg-plum-dark text-cream font-semibold flex items-center justify-center gap-2 transition-colors disabled:opacity-60">
              {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={18} />}{loading ? "Signing in..." : "Sign In"}
            </button>
          </div>
        </form>
        <p className="text-center text-cream/40 text-xs mt-6">Authorized ministry staff only.</p>
      </div>
    </div>
  );
}
